module.exports = __webpack_public_path__ + "static/media/empty_list.080d0fda.png";